import { render, staticRenderFns } from "./price.vue?vue&type=template&id=20c941d8&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"
import style0 from "./price.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c941d8')) {
      api.createRecord('20c941d8', component.options)
    } else {
      api.reload('20c941d8', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=20c941d8&", function () {
      api.rerender('20c941d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/price/price.vue"
export default component.exports